import * as React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
export var SectionHeader = function (_a) {
    var title = _a.title, children = _a.children, toolTipComponent = _a.toolTipComponent, handleClick = _a.handleClick;
    return (React.createElement("div", { className: "sui-flex sui-justify-between ", style: {
            width: '100%',
            margin: '25px 0 10px',
        } },
        React.createElement("div", { className: "sui-flex" },
            React.createElement(Typography, { variant: "h2", weight: "display" }, title),
            toolTipComponent && (React.createElement("div", { style: { paddingTop: 18, paddingLeft: 5 } },
                React.createElement("button", { type: "button", onClick: handleClick },
                    ' ',
                    React.createElement(InfoFilled, { color: "info", size: "small" }),
                    ' '),
                toolTipComponent))),
        children));
};
